'use client';

import { Toaster as Sonner, type ToasterProps } from 'sonner';

/** Kidzio's toast surface — light theme + design tokens. */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-[color:var(--kz-color-surface-card)] group-[.toaster]:text-[color:var(--kz-color-ink-primary)] group-[.toaster]:border-[color:var(--kz-color-border-subtle)] group-[.toaster]:shadow-lg group-[.toaster]:rounded-card',
          description: 'group-[.toast]:text-[color:var(--kz-color-ink-secondary)]',
          actionButton:
            'group-[.toast]:bg-[color:var(--kz-color-brand-primary)] group-[.toast]:text-white',
          cancelButton:
            'group-[.toast]:bg-[color:var(--kz-color-surface-sunken)] group-[.toast]:text-[color:var(--kz-color-ink-primary)]',
        },
      }}
      {...props}
    />
  );
}
